export const APP_VERSION = '0.1.1';
export const BUILD_DATE = '2026-06-25T14:23:53Z';
export const COMMIT_HASH = '3e5839cf';
export const BUILD_DATE_UTC = '2026-06-25T14:23:53Z';
export const BUILD_DATE_IST = '2026-06-25T19:53:53+05:30';
export const ENVIRONMENT = 'stage';
